import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useSearchParams } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { Range } from "react-range";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";
import Products from "../components/products/Products";
import { BsFillGridFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import ShopProducts from "../components/products/ShopProducts";
import Pagination from "../components/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  price_range_product,
  query_products,
  get_sizes_by_typearticle,
} from "../store/reducers/homeReducer";

const CategoryShop = () => {
  const originUrl = window.location.origin;
  const bgStyle = {
    backgroundImage: `url(${originUrl}/images/banner/shop.png)`,
  };

  let [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  console.log("CategoryShop-category", category);

  const dispatch = useDispatch();
  const { products, priceRange, latest_product, totalProduct, parPage, sizesByCategory, typearticles } =
    useSelector((state) => state.home);

  useEffect(() => {
    dispatch(price_range_product());
  }, [dispatch]);
  useEffect(() => {
    setState({
      values: [priceRange.low, priceRange.high],
    });
  }, [priceRange]);

  const [filter, setFilter] = useState(true);

  const [state, setState] = useState({
    values: [priceRange.low, priceRange.high],
  });
  const [rating, setRating] = useState("");
  const [styles, setStyles] = useState("grid");
  const [size, setSize] = useState("");
  const [typearticle, setTypearticle] = useState("");
  const [pageNumber, setPageNumber] = useState(1);

  const [sortPrice, setSortPrice] = useState("");
  const lowValue = state.values[0] || "";
  const highValue = state.values[1] || "";
  useEffect(() => {
    if (typearticle) {
      dispatch(get_sizes_by_typearticle(typearticle));
      setSize("");
    }
  }, [dispatch, typearticle]);

  useEffect(() => {
    dispatch(
      query_products({
        low: lowValue,
        high: highValue,
        category,
        typearticle,
        rating,
        size,
        sortPrice,
        pageNumber,
      }),
    );
  }, [dispatch, lowValue, highValue, category, typearticle, rating, size, sortPrice, pageNumber]);

  const resetRating = () => {
    setRating("");
    dispatch(
      query_products({
        low: state.values[0],
        high: state.values[1],
        category,
        typearticle,
        rating: "",
        size,
        sortPrice,
        pageNumber,
      }),
    );
  };

  return (
    <div>
      <Header />
      <section
        className="h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left"
        style={bgStyle}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Categoría </h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Inicio</Link>
                <span className="pt-1">
                  <IoIosArrowForward />
                </span>
                <span>Categoría </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className={` md:block hidden ${!filter ? "mb-6" : "mb-0"} `}>
            <button
              onClick={() => setFilter(!filter)}
              className="text-center w-full py-2 px-3 bg-indigo-500 text-white"
            >
              Filtrar productos
            </button>
          </div>

          <div className="w-full flex flex-wrap">
            <div
              className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${filter ? "md:h-0 md:overflow-hidden md:mb-6" : "md:h-auto md:overflow-auto md:mb-0"} `}
            >
              <div className="py-2 flex flex-col gap-5">
                <h2 className="text-3xl font-bold mb-3 text-slate-600">
                  Precio
                </h2>

                <Range
                  step={5}
                  min={priceRange.low}
                  max={priceRange.high}
                  values={state.values}
                  onChange={(values) => setState({ values })}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      className="w-full h-[6px] bg-slate-200 rounded-full cursor-pointer"
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      className="w-[15px] h-[15px] bg-[#059473] rounded-full"
                      {...props}
                    />
                  )}
                />
                <div>
                  <span className="text-slate-800 font-bold text-lg">
                    S/{Math.floor(state.values[0])} - S/
                    {Math.floor(state.values[1])}
                  </span>
                </div>
              </div>

              <div className="py-3 flex flex-col gap-4">
                <h2 className="text-3xl font-bold mb-3 text-slate-600">
                  Clasificación{" "}
                </h2>
                <div className="flex flex-col gap-3">
                  <div
                    onClick={() => setRating(5)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                  </div>

                  <div
                    onClick={() => setRating(4)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                  </div>

                  <div
                    onClick={() => setRating(3)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                  </div>

                  <div
                    onClick={() => setRating(2)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                  </div>

                  <div
                    onClick={() => setRating(1)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                  </div>

                  <div
                    onClick={resetRating}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                    <span>
                      <CiStar />{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="py-3 flex flex-col gap-4">
                <h2 className="text-3xl font-bold mb-3 text-slate-600">Tipo Artículo</h2>
                <div className="flex flex-col gap-2">
                  {typearticles.map((ta) => (
                    <label key={ta._id} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={typearticle === ta.name}
                        onChange={(e) => setTypearticle(e.target.checked ? ta.name : "")}
                        className="accent-[#059473]"
                      />
                      <span className="text-slate-600 text-sm">{ta.name}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="py-3 flex flex-col gap-4">
                <h2 className="text-3xl font-bold mb-3 text-slate-600">Tallas</h2>
                {!typearticle ? (
                  <p className="text-slate-400 text-sm">Selecciona un tipo de artículo para ver tallas</p>
                ) : sizesByCategory.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {sizesByCategory.map((s) => (
                      <button
                        key={s._id}
                        onClick={() => setSize(size === s.name ? "" : s.name)}
                        className={`px-3 py-1 border rounded text-sm font-medium transition-colors ${
                          size === s.name
                            ? "bg-[#059473] text-white border-[#059473]"
                            : "bg-white text-slate-600 border-slate-300 hover:border-[#059473]"
                        }`}
                      >
                        {s.name}
                      </button>
                    ))}
                  </div>
                ) : (
                  <p className="text-slate-400 text-sm">Sin tallas para este tipo de producto</p>
                )}
              </div>

              <div className="py-5 flex flex-col gap-4 md:hidden">
                <Products title="Novedades" products={latest_product} />
              </div>
            </div>

            <div className="w-full md:w-9/12 md-lg:w-8/12 xl:w-9/12">
              <div className="pl-8 md:pl-0">
                <div className="hidden md:flex py-4 bg-white mb-10 px-3 rounded-md  justify-between items-start border w-full">
                  <h2 className="text-lg font-medium text-slate-600">
                    {" "}
                    ({totalProduct}) Productos{" "}
                  </h2>
                  <div className="flex justify-center items-center gap-3">
                    <select
                      onChange={(e) => setSortPrice(e.target.value)}
                      className="p-1 border outline-0 text-slate-600 font-semibold"
                      name=""
                      id=""
                    >
                      <option value="">Ordenar por</option>
                      <option value="low-to-high">Precio bajo a alto</option>
                      <option value="high-to-low">Precio alto a bajo </option>
                    </select>
                    <div className="flex justify-center items-start gap-4 md-lg:hidden">
                      <div
                        onClick={() => setStyles("grid")}
                        className={`p-2 ${styles === "grid" && "bg-slate-300"} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `}
                      >
                        <BsFillGridFill />
                      </div>
                      <div
                        onClick={() => setStyles("list")}
                        className={`p-2 ${styles === "list" && "bg-slate-300"} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `}
                      >
                        <FaThList />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pb-8  w-full">
                  <ShopProducts products={products} styles={styles} />
                </div>

                <div>
                  {totalProduct > parPage && (
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      totalItem={totalProduct}
                      parPage={parPage}
                      showItem={Math.floor(totalProduct / parPage)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CategoryShop;
